import urlPrefix from "./apiPrefix";

export const getGeoClusters = () => `${urlPrefix.value}/tax-web-control/api/geo/clusters`;
